import { render, staticRenderFns } from "./GoodsPresaleDialog.vue?vue&type=template&id=777fc39c&scoped=true&"
import script from "./GoodsPresaleDialog.vue?vue&type=script&lang=js&"
export * from "./GoodsPresaleDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPresaleDialog.vue?vue&type=style&index=0&id=777fc39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777fc39c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777fc39c')) {
      api.createRecord('777fc39c', component.options)
    } else {
      api.reload('777fc39c', component.options)
    }
    module.hot.accept("./GoodsPresaleDialog.vue?vue&type=template&id=777fc39c&scoped=true&", function () {
      api.rerender('777fc39c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/GoodsPresaleDialog.vue"
export default component.exports